import { Component, EventEmitter, Inject, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { KitItemsModalComponent } from 'src/app/shared/components/kit-items-modal/kit-items-modal.component';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { KitService } from 'src/app/shared/services/API/pharmacy/kit.service';
import { ListKitStruct } from 'src/app/shared/services/structs/pharmacy/list-kit.struct';
import { MedicineService } from 'src/app/shared/services/API/pharmacy/medicine.service';
import { AdditionalItemForPrescriptionReleaseStruct } from 'src/app/shared/services/structs/pharmacy/additional-item-for-prescription-release.struct';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AdditionalElementsToKitSearchRequest } from 'src/app/shared/services/requests/pharmacy/additional-elements-to-kit-search.request';
import { AdditionalMedicineForPrescriptionReleaseFormStruct } from 'src/app/shared/services/structs/pharmacy/additional-medicine-for-prescription-release-form.struct';
import { AdditionalItemForPrescriptionReleaseFormStruct } from 'src/app/shared/services/structs/pharmacy/additional-item-for-prescription-release-form.struct';
import { AdditionalElementsForPrescriptionReleaseFormSearchRequest } from 'src/app/shared/services/requests/pharmacy/additional-elements-for-prescription-release-form-search.request';
import { ItemService } from 'src/app/shared/services/API/pharmacy/Item.service';
import { AdditionalMedicineForPrescriptionReleaseStruct } from 'src/app/shared/services/structs/pharmacy/additional-medicine-for-prescription-release.struct';

@Component({
    selector: 'app-additional-item-modal',
    templateUrl: './additional-item-modal.component.html',
    styleUrls: ['./additional-item-modal.component.css'],
    animations: [
        trigger('expandCollapse', [
            state('hidden', style({ height: '0px', opacity: 0, overflow: 'hidden' })),
            state('visible', style({ height: '*', opacity: 1 })),
            transition('hidden => visible', [
                animate('300ms ease-out')
            ]),
            transition('visible => hidden', [
                animate('200ms ease-in')
            ])
        ])
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AdditionalItemModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<AdditionalItemModalComponent>,
    private alertService: AlertService,
    private kitService: KitService,
    private itemService: ItemService,
    private medicineService: MedicineService,
    private formBuilder: FormBuilder,
  ) { }

  public model: FormGroup;
  public listKits: ListKitStruct[] = [];
  public listItem: AdditionalItemForPrescriptionReleaseFormStruct[] = [];
  public listMedicine: AdditionalMedicineForPrescriptionReleaseFormStruct[] = [];
  public listAdditionalItemsForRequest: AdditionalItemForPrescriptionReleaseFormStruct[] = [];
  public listAdditionalMedicinesForRequest: AdditionalMedicineForPrescriptionReleaseFormStruct[] = [];

  public isLoading: boolean = false;
  public isFirstLoading: boolean = true;
  public hasKitForDispensingItems: boolean = false;
  public isKitsVisible: boolean = false;

  ngOnInit(): void {
    this.model = this.formBuilder.group({
      listItems: this.formBuilder.array([]),
      listMedicines: this.formBuilder.array([]),
    });

    this.listAdditionalItemsForRequest = this.data.listAdditionalItemsForRequest;
    this.listAdditionalMedicinesForRequest = this.data.listAdditionalMedicinesForRequest;

    if ((this.listAdditionalItemsForRequest && this.listAdditionalItemsForRequest.length > 0)
      || (this.listAdditionalMedicinesForRequest && this.listAdditionalMedicinesForRequest.length > 0)) {
      this.populate();
    } else if (this.data.listIdKit && this.data.listIdKit.length > 0) {
      this.getAdditionalElementsForDispensing(this.data.listIdKit);
      this.populateMedicineList(null);
      this.populateItemList(null);
    }

    this.populateKitList();
  }

  submit() {
    const listModelItems = (this.model.controls['listItems'] as FormArray);
    const listModelMedicines = (this.model.controls['listMedicines'] as FormArray);

    if (this.model.invalid) {
      this.model.markAllAsTouched();
      this.alertService.show('Erro', "Preencha todos os campos obrigatórios!", AlertType.error);
      return;
    }
    this.listAdditionalItemsForRequest = [];
    this.listAdditionalMedicinesForRequest = [];

    if (listModelItems) {
      listModelItems.getRawValue().forEach(x => {
        var additionalItenForRequest = new AdditionalItemForPrescriptionReleaseFormStruct();
        additionalItenForRequest.additionalItemForPrescriptionRelease = new AdditionalItemForPrescriptionReleaseStruct();
        additionalItenForRequest.additionalItemForPrescriptionRelease.idItem = x.idItem;
        additionalItenForRequest.additionalItemForPrescriptionRelease.itemName = x.item.additionalItemForPrescriptionRelease.itemName;
        additionalItenForRequest.additionalItemForPrescriptionRelease.storageBatch = x.item.listStorageAmountLocationStruct.find(y => y.idStorage == x.idStorage)?.storageBatch;
        additionalItenForRequest.additionalItemForPrescriptionRelease.numberOfItens = x.quantity ? parseInt(x.quantity.replace(",", ".")) : null;
        additionalItenForRequest.additionalItemForPrescriptionRelease.idStorage = x.idStorage;
        additionalItenForRequest.listStorageAmountLocationStruct = x.item.listStorageAmountLocationStruct;
        this.listAdditionalItemsForRequest.push(additionalItenForRequest);
      });
    }
    if (listModelMedicines) {
      listModelMedicines.getRawValue().forEach(x => {
        var additionalMedicineForRequest = new AdditionalMedicineForPrescriptionReleaseFormStruct();
        additionalMedicineForRequest.additionalMedicineForPrescriptionRelease = new AdditionalMedicineForPrescriptionReleaseStruct();
        additionalMedicineForRequest.additionalMedicineForPrescriptionRelease.idMedicine = x.idItem;
        additionalMedicineForRequest.additionalMedicineForPrescriptionRelease.medicineDescription = x.item.additionalMedicineForPrescriptionRelease.medicineDescription;
        additionalMedicineForRequest.additionalMedicineForPrescriptionRelease.storageBatch = x.item.listStorageAmountLocationStruct.find(y => y.idStorage == x.idStorage)?.storageBatch;
        additionalMedicineForRequest.additionalMedicineForPrescriptionRelease.numberOfItens = x.quantity ? parseFloat(x.quantity.replace(",", ".")) : null;
        additionalMedicineForRequest.additionalMedicineForPrescriptionRelease.idStorage = x.idStorage;
        additionalMedicineForRequest.listStorageAmountLocationStruct = x.item.listStorageAmountLocationStruct;
        this.listAdditionalMedicinesForRequest.push(additionalMedicineForRequest);
      });
    }

    this.matDialogRef.close(
      {
        listAdditionalItemsForRequest: this.listAdditionalItemsForRequest,
        listAdditionalMedicinesForRequest: this.listAdditionalMedicinesForRequest,
      }
    );
  }

  populate() {
    if (this.listAdditionalItemsForRequest && this.listAdditionalItemsForRequest.length > 0) {
      this.mapNewItemFromKits(this.listAdditionalItemsForRequest);
    } else {
      this.populateItemList(null);
    }

    if (this.listAdditionalMedicinesForRequest && this.listAdditionalMedicinesForRequest.length > 0) {
      this.mapNewMedicineFromKits(this.listAdditionalMedicinesForRequest);
    } else {
      this.populateMedicineList(null);
    }
  }

  close() {
    this.matDialogRef.close();
  }

  createInputItem(item?: AdditionalItemForPrescriptionReleaseFormStruct) {
    if (item) {
      return this.formBuilder.group({
        idItem: [item.additionalItemForPrescriptionRelease.idItem, [Validators.required]],
        item: [item, [Validators.required]],
        quantity: [item.additionalItemForPrescriptionRelease.numberOfItens ? item.additionalItemForPrescriptionRelease.numberOfItens.toString() : '', [Validators.required]],
        idStorage: [item.additionalItemForPrescriptionRelease.idStorage, [Validators.required]],
      });
    }
    else {
      return this.formBuilder.group({
        idItem: [null, [Validators.required]],
        item: [null, [Validators.required]],
        quantity: [{ value: null, disabled: true }, [Validators.required]],
        idStorage: [{ value: null, disabled: true }, [Validators.required]],
      })
    }
  }

  addNextInputItem() {
    if (this.listItem.length == 0 && this.listMedicine.length == 0)
      return this.alertService.show('Alerta', "É necessário a seleção de um kit, para visualizar os itens.", AlertType.warning);

    (this.model.controls['listItems'] as FormArray).push(this.createInputItem());
  }

  removeInputItem(index: number) {
    (this.model.controls['listItems'] as FormArray).removeAt(index);

    if (this.model.get('listItems').value.length == 0 && this.model.get('listMedicines').value.length == 0) {
      this.listItem = [];
      this.listMedicine = [];
    }
  }

  createInputMedicine(item?: AdditionalMedicineForPrescriptionReleaseFormStruct) {
    if (item) {
      return this.formBuilder.group({
        idItem: [item.additionalMedicineForPrescriptionRelease.idMedicine, [Validators.required]],
        item: [item, [Validators.required]],
        quantity: [item.additionalMedicineForPrescriptionRelease.numberOfItens ? item.additionalMedicineForPrescriptionRelease.numberOfItens.toString() : '', [Validators.required]],
        idStorage: [item.additionalMedicineForPrescriptionRelease.idStorage, [Validators.required]],
      });
    }
    else {
      return this.formBuilder.group({
        idItem: [null, [Validators.required]],
        item: [null, [Validators.required]],
        quantity: [{ value: null, disabled: true }, [Validators.required]],
        idStorage: [{ value: null, disabled: true }, [Validators.required]],
      })
    }
  }

  addNextInputMedicine() {
    if (this.listItem.length == 0 && this.listMedicine.length == 0)
      return this.alertService.show('Alerta', "É necessário a seleção de um kit, para visualizar os medicamentos.", AlertType.warning);

    (this.model.controls['listMedicines'] as FormArray).push(this.createInputMedicine());
  }

  removeInputMedicine(index: number) {
    (this.model.controls['listMedicines'] as FormArray).removeAt(index);

    if (this.model.get('listItems').value.length == 0 && this.model.get('listMedicines').value.length == 0) {
      this.listItem = [];
      this.listMedicine = [];
    }
  }

  openKit(kit: ListKitStruct) {
    this.dialog.open(KitItemsModalComponent, {
      width: "700px",
      data: {
        idKit: kit.idKit,
      },
    });
  }

  populateKitList() {
    this.kitService.listKit(null, null).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }
        this.listKits = response.listKits;
        this.isLoading = false;
        this.isFirstLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  getAdditionalElementsForDispensing(listIdKit: number[] = []) {
    this.isLoading = true;
    let body = new AdditionalElementsToKitSearchRequest();
    body.listIdKit = listIdKit;
    
    if (this.data.isObservation) {
      body.idSector = this.data.idSector;
    }

    if (!listIdKit || listIdKit.length === 0 || (listIdKit.length === 1 && listIdKit.some(x => x === 0 || x === null)))
      return;

    this.kitService.GetAdditionalElementsByIdKit(body).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }

        if (response.listAdditionalItemForPrescriptionReleaseForm && response.listAdditionalItemForPrescriptionReleaseForm.length > 0)
          this.mapNewItemFromKits(response.listAdditionalItemForPrescriptionReleaseForm);

        if (response.listAdditionalMedicinesForPrescriptionReleaseForm && response.listAdditionalMedicinesForPrescriptionReleaseForm.length > 0)
          this.mapNewMedicineFromKits(response.listAdditionalMedicinesForPrescriptionReleaseForm);

        this.isLoading = false;
        this.isFirstLoading = false;

      },
      error: (error) => {
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  populateMedicineList(searchText: string) {

    if (searchText == "")
      searchText = null;

    let listModelMedicines = (this.model.controls['listMedicines'] as FormArray);

    let body = new AdditionalElementsForPrescriptionReleaseFormSearchRequest();
    body.searchText = searchText;
    body.listIdElementsMandatoryToGet = listModelMedicines.value.filter(x => x.idItem !== null).map(x => x.idItem);

    this.medicineService.GetListAdditionalMedicinesForKits(body).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }
        this.listMedicine = response.listAdditionalMedicinesForPrescriptionReleaseForm;
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  populateItemList(searchText: string) {

    if (searchText == "")
      searchText = null;

    let listModelItems = (this.model.controls['listItems'] as FormArray);

    let body = new AdditionalElementsForPrescriptionReleaseFormSearchRequest();
    body.searchText = searchText;
    body.listIdElementsMandatoryToGet = listModelItems.value.filter(x => x.idItem !== null).map(x => x.idItem);

    this.itemService.GetListAdditionalItensForKits(body).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }
        this.listItem = response.listAdditionalItemForPrescriptionReleaseForm;
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  mapNewItemFromKits(listAdditionalItems: AdditionalItemForPrescriptionReleaseFormStruct[]) {
    let listModelItems = (this.model.controls['listItems'] as FormArray);
    let currentIdValues = listModelItems.value.filter(x => x.idItem !== null).map(x => x.idItem);

    for (let i = 0; i < listAdditionalItems.length; i++) {
      let item = listAdditionalItems[i];
      if (!item.listStorageAmountLocationStruct.length || item.listStorageAmountLocationStruct.length == 0) {
        this.alertService.show('Aviso!', `Não há estoque para o item '${item.additionalItemForPrescriptionRelease.itemName}'`, AlertType.warning);
      }
      if (!currentIdValues.includes(item.additionalItemForPrescriptionRelease.idItem)) {
        listModelItems.push(this.createInputItem(item));
        continue;
      }

      let indexFormArray = listModelItems.value.findIndex(x => x.idItem == item.additionalItemForPrescriptionRelease.idItem);
      let newValue = listModelItems.at(indexFormArray).get('quantity').value + item.additionalItemForPrescriptionRelease.numberOfItens;
      listModelItems.at(indexFormArray).get('quantity').setValue(newValue);

      if (listModelItems.at(indexFormArray).get('idStorage').value) {
        let currentStorage = item.listStorageAmountLocationStruct.find(x => x.idStorage == listModelItems.at(indexFormArray).get('idStorage').value);
        if (currentStorage.amountRemaining < newValue)
          listModelItems.at(indexFormArray).get('idStorage').setValue(null);
      }
    }
    this.populateItemList(null);
    this.isKitsVisible = false;
  }

  mapNewMedicineFromKits(listAdditionalItems: AdditionalMedicineForPrescriptionReleaseFormStruct[]) {
    let listModelMedicines = (this.model.controls['listMedicines'] as FormArray);
    let currentIdValues = listModelMedicines.value.filter(x => x.idItem !== null).map(x => x.idItem);

    for (let i = 0; i < listAdditionalItems.length; i++) {
      let item = listAdditionalItems[i];
      if (!item.listStorageAmountLocationStruct.length || item.listStorageAmountLocationStruct.length == 0) {
        this.alertService.show('Aviso!', `Não há estoque para o medicamento '${item.additionalMedicineForPrescriptionRelease.medicineDescription}'`, AlertType.warning);
      }

      if (!currentIdValues.includes(item.additionalMedicineForPrescriptionRelease.idMedicine)) {
        listModelMedicines.push(this.createInputMedicine(item));
        continue;
      }

      let indexFormArray = listModelMedicines.value.findIndex(x => x.idItem == item.additionalMedicineForPrescriptionRelease.idMedicine);
      let newValue = listModelMedicines.at(indexFormArray).get('quantity').value + item.additionalMedicineForPrescriptionRelease.numberOfItens;
      listModelMedicines.at(indexFormArray).get('quantity').setValue(newValue);

      if (listModelMedicines.at(indexFormArray).get('idStorage').value) {
        let currentStorage = item.listStorageAmountLocationStruct.find(x => x.idStorage == listModelMedicines.at(indexFormArray).get('idStorage').value);

        if (currentStorage.amountRemaining < newValue)
          listModelMedicines.at(indexFormArray).get('idStorage').setValue(null);
      }
    }
    this.populateMedicineList(null);
    this.model.markAllAsTouched();
    this.isKitsVisible = false;
  }

  openAddItemInKits() {
    this.isKitsVisible = true;
  }

  verifyHasKitForDispensingItems() {
    this.hasKitForDispensingItems = this.listKits.find(x => x.selectForDispensingItems) ? true : false;
  }

  selectItem(idItem: number, indexFormArray) {
    let item = this.listItem.find(x => x.additionalItemForPrescriptionRelease.idItem == idItem);
    let listModelItems = (this.model.controls['listItems'] as FormArray);

    listModelItems.at(indexFormArray).get('item').setValue(item);

    if (!item.listStorageAmountLocationStruct.length || item.listStorageAmountLocationStruct.length == 0) {
      this.alertService.show('Aviso!', `Não há estoque para o medicamento '${item.additionalItemForPrescriptionRelease.itemName}'`, AlertType.warning);
    }

    if (!listModelItems.at(indexFormArray).get('quantity').value) {
      listModelItems.at(indexFormArray).get('quantity').enable();
    } else {
      listModelItems.at(indexFormArray).get('quantity').setValue(null);
      listModelItems.at(indexFormArray).get('idStorage').setValue(null);
      listModelItems.at(indexFormArray).get('idStorage').disable();
    }
  }

  selectMedicine(idItem: number, indexFormArray) {
    let item = this.listMedicine.find(x => x.additionalMedicineForPrescriptionRelease.idMedicine == idItem);
    let listModelMedicines = (this.model.controls['listMedicines'] as FormArray);

    listModelMedicines.at(indexFormArray).get('item').setValue(item);

    if (!item.listStorageAmountLocationStruct.length || item.listStorageAmountLocationStruct.length == 0) {
      this.alertService.show('Aviso!', `Não há estoque para o medicamento '${item.additionalMedicineForPrescriptionRelease.medicineDescription}'`, AlertType.warning);
    }

    if (!listModelMedicines.at(indexFormArray).get('quantity').value) {
      listModelMedicines.at(indexFormArray).get('quantity').enable();
    } else {
      listModelMedicines.at(indexFormArray).get('quantity').setValue(null);
      listModelMedicines.at(indexFormArray).get('quantity').disable();
      listModelMedicines.at(indexFormArray).get('idStorage').setValue(null);
      listModelMedicines.at(indexFormArray).get('idStorage').disable();
    }

  }

  verifyItemAlredySelected(idItem: number, currentIdItem: number) {
    let listModelItems = (this.model.controls['listItems'] as FormArray);
    let selectedValues = listModelItems.value.filter(x => x.idItem !== null).map(x => x.idItem)

    let isDifferentItem = false;
    if (!currentIdItem)
      isDifferentItem = true;
    else if (idItem !== currentIdItem)
      isDifferentItem = true;

    return (selectedValues.includes(idItem) && isDifferentItem);
  }

  verifyMedicineAlredySelected(idItem: number, currentIdItem: number) {
    let listModelMedicines = (this.model.controls['listMedicines'] as FormArray);
    let selectedValues = listModelMedicines.value.filter(x => x.idItem !== null).map(x => x.idItem)

    let isDifferentItem = false;
    if (!currentIdItem)
      isDifferentItem = true;
    else if (idItem !== currentIdItem)
      isDifferentItem = true;

    return (selectedValues.includes(idItem) && isDifferentItem);
  }

  private timeoutKeySearch: any = null;

  onKeyChangeQuantity(event: any, indexFormArray: number, nameControl: string) {
    clearTimeout(this.timeoutKeySearch);
    var $this = this;
    this.timeoutKeySearch = setTimeout(function () {
      if (event.keyCode != 13) {
        let listModel = ($this.model.controls[nameControl] as FormArray);
        listModel.at(indexFormArray).get('idStorage').enable();
      }
    }, 1000);

    this.model.markAllAsTouched();
  }

  onKeySearchItem(event: any) {
    clearTimeout(this.timeoutKeySearch);
    var $this = this;
    this.timeoutKeySearch = setTimeout(function () {
      if (event.keyCode != 13) {
        $this.populateItemList(event);
      }
    }, 1000);
  }

  onKeySearchMedicine(event: any) {
    clearTimeout(this.timeoutKeySearch);
    var $this = this;
    this.timeoutKeySearch = setTimeout(function () {
      if (event.keyCode != 13) {
        $this.populateMedicineList(event);
      }
    }, 1000);
  }

  cancelToDispenseKitItems() {
    this.isKitsVisible = false;
  }

  addKitItemsForDispense() {
    let listIdKit = this.listKits.filter(x => x.selectForDispensingItems).map(x => x.idKit);
    this.getAdditionalElementsForDispensing(listIdKit);
    this.listKits.forEach(x => x.selectForDispensingItems = false);
  }

}
